const familyRoboto = 'Roboto';
const familyNunito = 'Nunito';

const core = {
  // header fonts
  headingXXL: {
    fontFamily: familyNunito,
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: '48px',
    lineHeight: '60px',
  },
  headingXL: {
    fontFamily: familyNunito,
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: '34px',
    lineHeight: '40px',
  },
  headingL: {
    fontFamily: familyNunito,
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '26px',
    lineHeight: '32px',
  },
  subHeading: {
    fontFamily: familyNunito,
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: '20px',
    lineHeight: '28px',
  },

  // body fonts
  textLead: {
    fontFamily: familyRoboto,
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '20px',
    lineHeight: '28px',
  },
  textBasis: {
    fontFamily: familyRoboto,
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '18px',
    lineHeight: '24px',
  },
  textBasisMedium: {
    fontFamily: familyRoboto,
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '18px',
    lineHeight: '24px',
  },
  textBasisBold: {
    fontFamily: familyRoboto,
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: '18px',
    lineHeight: '24px',
  },
  textSmall: {
    fontFamily: familyRoboto,
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '20px',
  },
  textSmallMedium: {
    fontFamily: familyRoboto,
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '16px',
    lineHeight: '20px',
  },
  textExtraSmall: {
    fontFamily: familyRoboto,
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '18px',
  },
  textExtraSmallMedium: {
    fontFamily: familyRoboto,
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '18px',
  },
};

const getFontSize = (font, setSize = null, multiplier = 3) => {
  const fontObject = (value) => ({ fontSize: `${value}px` });
  if (typeof setSize === 'number' && setSize > 0) {
    return fontObject(setSize);
  }
  // eslint-disable-next-line radix
  return fontObject(parseInt(font.fontSize) * multiplier);
};

const getFontSizeByKey = (fontKey, setSize = null, multiplier = 3) => {
  const font = core[fontKey];

  if (font === undefined) {
    return undefined;
  }
  const fontSize = getFontSize(font, setSize, multiplier);
  return fontSize;
};

const getFontByKey = (fontKey) => {
  const font = core[fontKey];

  if (font === undefined) {
    return {};
  }

  return font;
};

const helper = {
  getFontSize,
  getFontSizeByKey,
  getFontByKey,
};

const fontStyles = {
  core,
  helper,
};

export default fontStyles;
